import { prepareFormDataId } from '@/utils/form/prepareFormDataId'
import { prepareFormDataCommaToDot } from '@/utils/form/prepareFormDataCommaToDot'
import { POSITION_FIELDS_COMMA_TO_DOT, POSITION_FIELDS_HANDBOOK } from '@/const/production/position'

export function prepareFormDataPosition (data) {
  const formData = prepareFormDataId(data, POSITION_FIELDS_HANDBOOK)
  return prepareFormDataCommaToDot(formData, POSITION_FIELDS_COMMA_TO_DOT)
}
